export default __webpack_public_path__ + "static/media/ic_wbnb_96.16de3342.svg";